/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AgencyBrandListParams,
  AgencyProfile,
  AgencyProfileListParams,
  AgencyProfileRequest,
  BrandIdentity,
  BrandIdentityRequest,
  LogoUploadRequest,
  PaginatedAgencyProfileList,
  PaginatedBrandIdentityList,
  PatchedAgencyProfileRequest,
  PatchedBrandIdentityRequest
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * One object per agency: `list` returns it, `current` reads or changes it.
 */
export type agencyBrandListResponse200 = {
  data: PaginatedBrandIdentityList
  status: 200
}
    
export type agencyBrandListResponseSuccess = (agencyBrandListResponse200) & {
  headers: Headers;
};
;

export type agencyBrandListResponse = (agencyBrandListResponseSuccess)

export const getAgencyBrandListUrl = (params?: AgencyBrandListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/agency/brand/?${stringifiedParams}` : `/api/v1/agency/brand/`
}

export const agencyBrandList = async (params?: AgencyBrandListParams, options?: RequestInit): Promise<agencyBrandListResponse> => {
  
  return apiFetch<agencyBrandListResponse>(getAgencyBrandListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAgencyBrandListQueryKey = (params?: AgencyBrandListParams,) => {
    return [
    `/api/v1/agency/brand/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAgencyBrandListQueryOptions = <TData = Awaited<ReturnType<typeof agencyBrandList>>, TError = unknown>(params?: AgencyBrandListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyBrandList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgencyBrandListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof agencyBrandList>>> = ({ signal }) => agencyBrandList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agencyBrandList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgencyBrandListQueryResult = NonNullable<Awaited<ReturnType<typeof agencyBrandList>>>
export type AgencyBrandListQueryError = unknown


export function useAgencyBrandList<TData = Awaited<ReturnType<typeof agencyBrandList>>, TError = unknown>(
 params: undefined |  AgencyBrandListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyBrandList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyBrandList>>,
          TError,
          Awaited<ReturnType<typeof agencyBrandList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyBrandList<TData = Awaited<ReturnType<typeof agencyBrandList>>, TError = unknown>(
 params?: AgencyBrandListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyBrandList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyBrandList>>,
          TError,
          Awaited<ReturnType<typeof agencyBrandList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyBrandList<TData = Awaited<ReturnType<typeof agencyBrandList>>, TError = unknown>(
 params?: AgencyBrandListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyBrandList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAgencyBrandList<TData = Awaited<ReturnType<typeof agencyBrandList>>, TError = unknown>(
 params?: AgencyBrandListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyBrandList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgencyBrandListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One object per agency: `list` returns it, `current` reads or changes it.
 */
export type agencyBrandRetrieveResponse200 = {
  data: BrandIdentity
  status: 200
}
    
export type agencyBrandRetrieveResponseSuccess = (agencyBrandRetrieveResponse200) & {
  headers: Headers;
};
;

export type agencyBrandRetrieveResponse = (agencyBrandRetrieveResponseSuccess)

export const getAgencyBrandRetrieveUrl = (id: string,) => {


  

  return `/api/v1/agency/brand/${id}/`
}

export const agencyBrandRetrieve = async (id: string, options?: RequestInit): Promise<agencyBrandRetrieveResponse> => {
  
  return apiFetch<agencyBrandRetrieveResponse>(getAgencyBrandRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAgencyBrandRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/agency/brand/${id}/`
    ] as const;
    }

    
export const getAgencyBrandRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof agencyBrandRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyBrandRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgencyBrandRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof agencyBrandRetrieve>>> = ({ signal }) => agencyBrandRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agencyBrandRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgencyBrandRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof agencyBrandRetrieve>>>
export type AgencyBrandRetrieveQueryError = unknown


export function useAgencyBrandRetrieve<TData = Awaited<ReturnType<typeof agencyBrandRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyBrandRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyBrandRetrieve>>,
          TError,
          Awaited<ReturnType<typeof agencyBrandRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyBrandRetrieve<TData = Awaited<ReturnType<typeof agencyBrandRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyBrandRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyBrandRetrieve>>,
          TError,
          Awaited<ReturnType<typeof agencyBrandRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyBrandRetrieve<TData = Awaited<ReturnType<typeof agencyBrandRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyBrandRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAgencyBrandRetrieve<TData = Awaited<ReturnType<typeof agencyBrandRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyBrandRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgencyBrandRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One object per agency: `list` returns it, `current` reads or changes it.
 */
export type agencyBrandUpdateResponse200 = {
  data: BrandIdentity
  status: 200
}
    
export type agencyBrandUpdateResponseSuccess = (agencyBrandUpdateResponse200) & {
  headers: Headers;
};
;

export type agencyBrandUpdateResponse = (agencyBrandUpdateResponseSuccess)

export const getAgencyBrandUpdateUrl = (id: string,) => {


  

  return `/api/v1/agency/brand/${id}/`
}

export const agencyBrandUpdate = async (id: string,
    brandIdentityRequest: BrandIdentityRequest, options?: RequestInit): Promise<agencyBrandUpdateResponse> => {
  
  return apiFetch<agencyBrandUpdateResponse>(getAgencyBrandUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      brandIdentityRequest,)
  }
);}




export const getAgencyBrandUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agencyBrandUpdate>>, TError,{id: string;data: BrandIdentityRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof agencyBrandUpdate>>, TError,{id: string;data: BrandIdentityRequest}, TContext> => {

const mutationKey = ['agencyBrandUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof agencyBrandUpdate>>, {id: string;data: BrandIdentityRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  agencyBrandUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AgencyBrandUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof agencyBrandUpdate>>>
    export type AgencyBrandUpdateMutationBody = BrandIdentityRequest
    export type AgencyBrandUpdateMutationError = unknown

    export const useAgencyBrandUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agencyBrandUpdate>>, TError,{id: string;data: BrandIdentityRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof agencyBrandUpdate>>,
        TError,
        {id: string;data: BrandIdentityRequest},
        TContext
      > => {

      const mutationOptions = getAgencyBrandUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * One object per agency: `list` returns it, `current` reads or changes it.
 */
export type agencyBrandPartialUpdateResponse200 = {
  data: BrandIdentity
  status: 200
}
    
export type agencyBrandPartialUpdateResponseSuccess = (agencyBrandPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type agencyBrandPartialUpdateResponse = (agencyBrandPartialUpdateResponseSuccess)

export const getAgencyBrandPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/agency/brand/${id}/`
}

export const agencyBrandPartialUpdate = async (id: string,
    patchedBrandIdentityRequest: PatchedBrandIdentityRequest, options?: RequestInit): Promise<agencyBrandPartialUpdateResponse> => {
  
  return apiFetch<agencyBrandPartialUpdateResponse>(getAgencyBrandPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedBrandIdentityRequest,)
  }
);}




export const getAgencyBrandPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agencyBrandPartialUpdate>>, TError,{id: string;data: PatchedBrandIdentityRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof agencyBrandPartialUpdate>>, TError,{id: string;data: PatchedBrandIdentityRequest}, TContext> => {

const mutationKey = ['agencyBrandPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof agencyBrandPartialUpdate>>, {id: string;data: PatchedBrandIdentityRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  agencyBrandPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AgencyBrandPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof agencyBrandPartialUpdate>>>
    export type AgencyBrandPartialUpdateMutationBody = PatchedBrandIdentityRequest
    export type AgencyBrandPartialUpdateMutationError = unknown

    export const useAgencyBrandPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agencyBrandPartialUpdate>>, TError,{id: string;data: PatchedBrandIdentityRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof agencyBrandPartialUpdate>>,
        TError,
        {id: string;data: PatchedBrandIdentityRequest},
        TContext
      > => {

      const mutationOptions = getAgencyBrandPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * One object per agency: `list` returns it, `current` reads or changes it.
 */
export type agencyBrandCurrentRetrieveResponse200 = {
  data: BrandIdentity
  status: 200
}
    
export type agencyBrandCurrentRetrieveResponseSuccess = (agencyBrandCurrentRetrieveResponse200) & {
  headers: Headers;
};
;

export type agencyBrandCurrentRetrieveResponse = (agencyBrandCurrentRetrieveResponseSuccess)

export const getAgencyBrandCurrentRetrieveUrl = () => {


  

  return `/api/v1/agency/brand/current/`
}

export const agencyBrandCurrentRetrieve = async ( options?: RequestInit): Promise<agencyBrandCurrentRetrieveResponse> => {
  
  return apiFetch<agencyBrandCurrentRetrieveResponse>(getAgencyBrandCurrentRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAgencyBrandCurrentRetrieveQueryKey = () => {
    return [
    `/api/v1/agency/brand/current/`
    ] as const;
    }

    
export const getAgencyBrandCurrentRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof agencyBrandCurrentRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyBrandCurrentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgencyBrandCurrentRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof agencyBrandCurrentRetrieve>>> = ({ signal }) => agencyBrandCurrentRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agencyBrandCurrentRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgencyBrandCurrentRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof agencyBrandCurrentRetrieve>>>
export type AgencyBrandCurrentRetrieveQueryError = unknown


export function useAgencyBrandCurrentRetrieve<TData = Awaited<ReturnType<typeof agencyBrandCurrentRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyBrandCurrentRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyBrandCurrentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof agencyBrandCurrentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyBrandCurrentRetrieve<TData = Awaited<ReturnType<typeof agencyBrandCurrentRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyBrandCurrentRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyBrandCurrentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof agencyBrandCurrentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyBrandCurrentRetrieve<TData = Awaited<ReturnType<typeof agencyBrandCurrentRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyBrandCurrentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAgencyBrandCurrentRetrieve<TData = Awaited<ReturnType<typeof agencyBrandCurrentRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyBrandCurrentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgencyBrandCurrentRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One object per agency: `list` returns it, `current` reads or changes it.
 */
export type agencyBrandCurrentPartialUpdateResponse200 = {
  data: BrandIdentity
  status: 200
}
    
export type agencyBrandCurrentPartialUpdateResponseSuccess = (agencyBrandCurrentPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type agencyBrandCurrentPartialUpdateResponse = (agencyBrandCurrentPartialUpdateResponseSuccess)

export const getAgencyBrandCurrentPartialUpdateUrl = () => {


  

  return `/api/v1/agency/brand/current/`
}

export const agencyBrandCurrentPartialUpdate = async (patchedBrandIdentityRequest: PatchedBrandIdentityRequest, options?: RequestInit): Promise<agencyBrandCurrentPartialUpdateResponse> => {
  
  return apiFetch<agencyBrandCurrentPartialUpdateResponse>(getAgencyBrandCurrentPartialUpdateUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedBrandIdentityRequest,)
  }
);}




export const getAgencyBrandCurrentPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agencyBrandCurrentPartialUpdate>>, TError,{data: PatchedBrandIdentityRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof agencyBrandCurrentPartialUpdate>>, TError,{data: PatchedBrandIdentityRequest}, TContext> => {

const mutationKey = ['agencyBrandCurrentPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof agencyBrandCurrentPartialUpdate>>, {data: PatchedBrandIdentityRequest}> = (props) => {
          const {data} = props ?? {};

          return  agencyBrandCurrentPartialUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AgencyBrandCurrentPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof agencyBrandCurrentPartialUpdate>>>
    export type AgencyBrandCurrentPartialUpdateMutationBody = PatchedBrandIdentityRequest
    export type AgencyBrandCurrentPartialUpdateMutationError = unknown

    export const useAgencyBrandCurrentPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agencyBrandCurrentPartialUpdate>>, TError,{data: PatchedBrandIdentityRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof agencyBrandCurrentPartialUpdate>>,
        TError,
        {data: PatchedBrandIdentityRequest},
        TContext
      > => {

      const mutationOptions = getAgencyBrandCurrentPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Upload (multipart) or remove the logo; checked and re-encoded as PNG.
 */
export type agencyBrandCurrentLogoCreateResponse200 = {
  data: BrandIdentity
  status: 200
}
    
export type agencyBrandCurrentLogoCreateResponseSuccess = (agencyBrandCurrentLogoCreateResponse200) & {
  headers: Headers;
};
;

export type agencyBrandCurrentLogoCreateResponse = (agencyBrandCurrentLogoCreateResponseSuccess)

export const getAgencyBrandCurrentLogoCreateUrl = () => {


  

  return `/api/v1/agency/brand/current/logo/`
}

export const agencyBrandCurrentLogoCreate = async (logoUploadRequest: LogoUploadRequest, options?: RequestInit): Promise<agencyBrandCurrentLogoCreateResponse> => {
    const formData = new FormData();
formData.append(`logo`, logoUploadRequest.logo)

  return apiFetch<agencyBrandCurrentLogoCreateResponse>(getAgencyBrandCurrentLogoCreateUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getAgencyBrandCurrentLogoCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agencyBrandCurrentLogoCreate>>, TError,{data: LogoUploadRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof agencyBrandCurrentLogoCreate>>, TError,{data: LogoUploadRequest}, TContext> => {

const mutationKey = ['agencyBrandCurrentLogoCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof agencyBrandCurrentLogoCreate>>, {data: LogoUploadRequest}> = (props) => {
          const {data} = props ?? {};

          return  agencyBrandCurrentLogoCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AgencyBrandCurrentLogoCreateMutationResult = NonNullable<Awaited<ReturnType<typeof agencyBrandCurrentLogoCreate>>>
    export type AgencyBrandCurrentLogoCreateMutationBody = LogoUploadRequest
    export type AgencyBrandCurrentLogoCreateMutationError = unknown

    export const useAgencyBrandCurrentLogoCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agencyBrandCurrentLogoCreate>>, TError,{data: LogoUploadRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof agencyBrandCurrentLogoCreate>>,
        TError,
        {data: LogoUploadRequest},
        TContext
      > => {

      const mutationOptions = getAgencyBrandCurrentLogoCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Upload (multipart) or remove the logo; checked and re-encoded as PNG.
 */
export type agencyBrandCurrentLogoDestroyResponse204 = {
  data: void
  status: 204
}
    
export type agencyBrandCurrentLogoDestroyResponseSuccess = (agencyBrandCurrentLogoDestroyResponse204) & {
  headers: Headers;
};
;

export type agencyBrandCurrentLogoDestroyResponse = (agencyBrandCurrentLogoDestroyResponseSuccess)

export const getAgencyBrandCurrentLogoDestroyUrl = () => {


  

  return `/api/v1/agency/brand/current/logo/`
}

export const agencyBrandCurrentLogoDestroy = async ( options?: RequestInit): Promise<agencyBrandCurrentLogoDestroyResponse> => {
  
  return apiFetch<agencyBrandCurrentLogoDestroyResponse>(getAgencyBrandCurrentLogoDestroyUrl(),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getAgencyBrandCurrentLogoDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agencyBrandCurrentLogoDestroy>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof agencyBrandCurrentLogoDestroy>>, TError,void, TContext> => {

const mutationKey = ['agencyBrandCurrentLogoDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof agencyBrandCurrentLogoDestroy>>, void> = () => {
          

          return  agencyBrandCurrentLogoDestroy(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AgencyBrandCurrentLogoDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof agencyBrandCurrentLogoDestroy>>>
    
    export type AgencyBrandCurrentLogoDestroyMutationError = unknown

    export const useAgencyBrandCurrentLogoDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agencyBrandCurrentLogoDestroy>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof agencyBrandCurrentLogoDestroy>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAgencyBrandCurrentLogoDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * One object per agency: `list` returns it, `current` reads or changes it.
 */
export type agencyProfileListResponse200 = {
  data: PaginatedAgencyProfileList
  status: 200
}
    
export type agencyProfileListResponseSuccess = (agencyProfileListResponse200) & {
  headers: Headers;
};
;

export type agencyProfileListResponse = (agencyProfileListResponseSuccess)

export const getAgencyProfileListUrl = (params?: AgencyProfileListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/agency/profile/?${stringifiedParams}` : `/api/v1/agency/profile/`
}

export const agencyProfileList = async (params?: AgencyProfileListParams, options?: RequestInit): Promise<agencyProfileListResponse> => {
  
  return apiFetch<agencyProfileListResponse>(getAgencyProfileListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAgencyProfileListQueryKey = (params?: AgencyProfileListParams,) => {
    return [
    `/api/v1/agency/profile/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAgencyProfileListQueryOptions = <TData = Awaited<ReturnType<typeof agencyProfileList>>, TError = unknown>(params?: AgencyProfileListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyProfileList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgencyProfileListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof agencyProfileList>>> = ({ signal }) => agencyProfileList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agencyProfileList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgencyProfileListQueryResult = NonNullable<Awaited<ReturnType<typeof agencyProfileList>>>
export type AgencyProfileListQueryError = unknown


export function useAgencyProfileList<TData = Awaited<ReturnType<typeof agencyProfileList>>, TError = unknown>(
 params: undefined |  AgencyProfileListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyProfileList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyProfileList>>,
          TError,
          Awaited<ReturnType<typeof agencyProfileList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyProfileList<TData = Awaited<ReturnType<typeof agencyProfileList>>, TError = unknown>(
 params?: AgencyProfileListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyProfileList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyProfileList>>,
          TError,
          Awaited<ReturnType<typeof agencyProfileList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyProfileList<TData = Awaited<ReturnType<typeof agencyProfileList>>, TError = unknown>(
 params?: AgencyProfileListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyProfileList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAgencyProfileList<TData = Awaited<ReturnType<typeof agencyProfileList>>, TError = unknown>(
 params?: AgencyProfileListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyProfileList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgencyProfileListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One object per agency: `list` returns it, `current` reads or changes it.
 */
export type agencyProfileRetrieveResponse200 = {
  data: AgencyProfile
  status: 200
}
    
export type agencyProfileRetrieveResponseSuccess = (agencyProfileRetrieveResponse200) & {
  headers: Headers;
};
;

export type agencyProfileRetrieveResponse = (agencyProfileRetrieveResponseSuccess)

export const getAgencyProfileRetrieveUrl = (id: string,) => {


  

  return `/api/v1/agency/profile/${id}/`
}

export const agencyProfileRetrieve = async (id: string, options?: RequestInit): Promise<agencyProfileRetrieveResponse> => {
  
  return apiFetch<agencyProfileRetrieveResponse>(getAgencyProfileRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAgencyProfileRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/agency/profile/${id}/`
    ] as const;
    }

    
export const getAgencyProfileRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof agencyProfileRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyProfileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgencyProfileRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof agencyProfileRetrieve>>> = ({ signal }) => agencyProfileRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agencyProfileRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgencyProfileRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof agencyProfileRetrieve>>>
export type AgencyProfileRetrieveQueryError = unknown


export function useAgencyProfileRetrieve<TData = Awaited<ReturnType<typeof agencyProfileRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyProfileRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyProfileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof agencyProfileRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyProfileRetrieve<TData = Awaited<ReturnType<typeof agencyProfileRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyProfileRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyProfileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof agencyProfileRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyProfileRetrieve<TData = Awaited<ReturnType<typeof agencyProfileRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyProfileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAgencyProfileRetrieve<TData = Awaited<ReturnType<typeof agencyProfileRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyProfileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgencyProfileRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One object per agency: `list` returns it, `current` reads or changes it.
 */
export type agencyProfileUpdateResponse200 = {
  data: AgencyProfile
  status: 200
}
    
export type agencyProfileUpdateResponseSuccess = (agencyProfileUpdateResponse200) & {
  headers: Headers;
};
;

export type agencyProfileUpdateResponse = (agencyProfileUpdateResponseSuccess)

export const getAgencyProfileUpdateUrl = (id: string,) => {


  

  return `/api/v1/agency/profile/${id}/`
}

export const agencyProfileUpdate = async (id: string,
    agencyProfileRequest: AgencyProfileRequest, options?: RequestInit): Promise<agencyProfileUpdateResponse> => {
  
  return apiFetch<agencyProfileUpdateResponse>(getAgencyProfileUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      agencyProfileRequest,)
  }
);}




export const getAgencyProfileUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agencyProfileUpdate>>, TError,{id: string;data: AgencyProfileRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof agencyProfileUpdate>>, TError,{id: string;data: AgencyProfileRequest}, TContext> => {

const mutationKey = ['agencyProfileUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof agencyProfileUpdate>>, {id: string;data: AgencyProfileRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  agencyProfileUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AgencyProfileUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof agencyProfileUpdate>>>
    export type AgencyProfileUpdateMutationBody = AgencyProfileRequest
    export type AgencyProfileUpdateMutationError = unknown

    export const useAgencyProfileUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agencyProfileUpdate>>, TError,{id: string;data: AgencyProfileRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof agencyProfileUpdate>>,
        TError,
        {id: string;data: AgencyProfileRequest},
        TContext
      > => {

      const mutationOptions = getAgencyProfileUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * One object per agency: `list` returns it, `current` reads or changes it.
 */
export type agencyProfilePartialUpdateResponse200 = {
  data: AgencyProfile
  status: 200
}
    
export type agencyProfilePartialUpdateResponseSuccess = (agencyProfilePartialUpdateResponse200) & {
  headers: Headers;
};
;

export type agencyProfilePartialUpdateResponse = (agencyProfilePartialUpdateResponseSuccess)

export const getAgencyProfilePartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/agency/profile/${id}/`
}

export const agencyProfilePartialUpdate = async (id: string,
    patchedAgencyProfileRequest: PatchedAgencyProfileRequest, options?: RequestInit): Promise<agencyProfilePartialUpdateResponse> => {
  
  return apiFetch<agencyProfilePartialUpdateResponse>(getAgencyProfilePartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedAgencyProfileRequest,)
  }
);}




export const getAgencyProfilePartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agencyProfilePartialUpdate>>, TError,{id: string;data: PatchedAgencyProfileRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof agencyProfilePartialUpdate>>, TError,{id: string;data: PatchedAgencyProfileRequest}, TContext> => {

const mutationKey = ['agencyProfilePartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof agencyProfilePartialUpdate>>, {id: string;data: PatchedAgencyProfileRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  agencyProfilePartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AgencyProfilePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof agencyProfilePartialUpdate>>>
    export type AgencyProfilePartialUpdateMutationBody = PatchedAgencyProfileRequest
    export type AgencyProfilePartialUpdateMutationError = unknown

    export const useAgencyProfilePartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agencyProfilePartialUpdate>>, TError,{id: string;data: PatchedAgencyProfileRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof agencyProfilePartialUpdate>>,
        TError,
        {id: string;data: PatchedAgencyProfileRequest},
        TContext
      > => {

      const mutationOptions = getAgencyProfilePartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * One object per agency: `list` returns it, `current` reads or changes it.
 */
export type agencyProfileCurrentRetrieveResponse200 = {
  data: AgencyProfile
  status: 200
}
    
export type agencyProfileCurrentRetrieveResponseSuccess = (agencyProfileCurrentRetrieveResponse200) & {
  headers: Headers;
};
;

export type agencyProfileCurrentRetrieveResponse = (agencyProfileCurrentRetrieveResponseSuccess)

export const getAgencyProfileCurrentRetrieveUrl = () => {


  

  return `/api/v1/agency/profile/current/`
}

export const agencyProfileCurrentRetrieve = async ( options?: RequestInit): Promise<agencyProfileCurrentRetrieveResponse> => {
  
  return apiFetch<agencyProfileCurrentRetrieveResponse>(getAgencyProfileCurrentRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAgencyProfileCurrentRetrieveQueryKey = () => {
    return [
    `/api/v1/agency/profile/current/`
    ] as const;
    }

    
export const getAgencyProfileCurrentRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof agencyProfileCurrentRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyProfileCurrentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgencyProfileCurrentRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof agencyProfileCurrentRetrieve>>> = ({ signal }) => agencyProfileCurrentRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agencyProfileCurrentRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgencyProfileCurrentRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof agencyProfileCurrentRetrieve>>>
export type AgencyProfileCurrentRetrieveQueryError = unknown


export function useAgencyProfileCurrentRetrieve<TData = Awaited<ReturnType<typeof agencyProfileCurrentRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyProfileCurrentRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyProfileCurrentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof agencyProfileCurrentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyProfileCurrentRetrieve<TData = Awaited<ReturnType<typeof agencyProfileCurrentRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyProfileCurrentRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyProfileCurrentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof agencyProfileCurrentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyProfileCurrentRetrieve<TData = Awaited<ReturnType<typeof agencyProfileCurrentRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyProfileCurrentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAgencyProfileCurrentRetrieve<TData = Awaited<ReturnType<typeof agencyProfileCurrentRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyProfileCurrentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgencyProfileCurrentRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * One object per agency: `list` returns it, `current` reads or changes it.
 */
export type agencyProfileCurrentPartialUpdateResponse200 = {
  data: AgencyProfile
  status: 200
}
    
export type agencyProfileCurrentPartialUpdateResponseSuccess = (agencyProfileCurrentPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type agencyProfileCurrentPartialUpdateResponse = (agencyProfileCurrentPartialUpdateResponseSuccess)

export const getAgencyProfileCurrentPartialUpdateUrl = () => {


  

  return `/api/v1/agency/profile/current/`
}

export const agencyProfileCurrentPartialUpdate = async (patchedAgencyProfileRequest: PatchedAgencyProfileRequest, options?: RequestInit): Promise<agencyProfileCurrentPartialUpdateResponse> => {
  
  return apiFetch<agencyProfileCurrentPartialUpdateResponse>(getAgencyProfileCurrentPartialUpdateUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedAgencyProfileRequest,)
  }
);}




export const getAgencyProfileCurrentPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agencyProfileCurrentPartialUpdate>>, TError,{data: PatchedAgencyProfileRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof agencyProfileCurrentPartialUpdate>>, TError,{data: PatchedAgencyProfileRequest}, TContext> => {

const mutationKey = ['agencyProfileCurrentPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof agencyProfileCurrentPartialUpdate>>, {data: PatchedAgencyProfileRequest}> = (props) => {
          const {data} = props ?? {};

          return  agencyProfileCurrentPartialUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AgencyProfileCurrentPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof agencyProfileCurrentPartialUpdate>>>
    export type AgencyProfileCurrentPartialUpdateMutationBody = PatchedAgencyProfileRequest
    export type AgencyProfileCurrentPartialUpdateMutationError = unknown

    export const useAgencyProfileCurrentPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof agencyProfileCurrentPartialUpdate>>, TError,{data: PatchedAgencyProfileRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof agencyProfileCurrentPartialUpdate>>,
        TError,
        {data: PatchedAgencyProfileRequest},
        TContext
      > => {

      const mutationOptions = getAgencyProfileCurrentPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    